"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ProgressBar = function (_a) {
    var blue = _a.blue, className = _a.className, _b = _a.el, ProgressBarElement = _b === void 0 ? 'progress' : _b, green = _a.green, indeterminate = _a.indeterminate, progress = _a.progress, position = _a.position, red = _a.red, small = _a.small, yellow = _a.yellow, props = __rest(_a, ["blue", "className", "el", "green", "indeterminate", "progress", "position", "red", "small", "yellow"]);
    var ProgressBarClasses = classnames_1.default('ProgressBar', className, {
        'ProgressBar--blue': blue,
        'ProgressBar--bottom': position === 'bottom',
        'ProgressBar--green': green,
        'ProgressBar--indeterminate': indeterminate,
        'ProgressBar--red': red,
        'ProgressBar--small': small,
        'ProgressBar--top': position === 'top',
        'ProgressBar--yellow': yellow,
    });
    if (indeterminate) {
        return (react_1.default.createElement("div", __assign({ className: ProgressBarClasses }, props),
            react_1.default.createElement("div", { className: "ProgressBar__bg" },
                react_1.default.createElement("div", { className: "ProgressBar__value" }))));
    }
    return (react_1.default.createElement(ProgressBarElement, __assign({ className: ProgressBarClasses, max: "100", value: progress }, props),
        react_1.default.createElement("div", { className: "ProgressBar__bg", role: "presentation" },
            react_1.default.createElement("div", { className: "ProgressBar__value", style: { width: progress + "%" } }))));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map